import * as c from '../constants/research';
import * as pages from '../constants/pages';
import { setMainPage } from './app';
import { setScene } from './unity';
import { announce } from './announcements';

export const loadResearch = (exercises, grades) => {
  // generate sequence for next/prev buttons
  const sequence = exercises
    .filter((ex) => ex.category !== 'build')
    .map((ex) => ex.code);

  // add unity scene to interactive exercises
  let scene = 2; // scene 0 is engineering, scene 1 is simulation, remaining are interactives
  exercises.forEach((ex) => {
    if (ex.category === 'interactive') {
      ex.unityScene = scene++;
    }
  });

  // build quiz/research questions from what may already exist in grades (others may be loaded when the exercise is first started)
  const questions = grades.reduce((collection, grade) => {
    if (grade.responses && grade.responses.length) {
      for (let i = 0; i < grade.responses.length; i++) {
        collection.push({
          exerciseCode: grade.exerciseCode,
          ...grade.responses[i].question,
        });
      }
    }
    return collection;
  }, []);

  return {
    type: c.RESEARCH_LOAD_DATA,
    exercises,
    questions,
    sequence,
  };
};

/**
 * Sets the research page. Also sets to the correct main page and any other
 * required state changes based on the page category.
 *
 * @param page
 */
export const setPage = (page) => (dispatch, getState) => {
  const {
    research: { isHelpOpen },
    app: { page: appPage },
  } = getState();

  // Update Unity scene if necessary for this page
  if (page.hasOwnProperty('unityScene')) {
    dispatch(setScene(page.unityScene));
  }

  if (page.category === 'tutorial') {
    // If tutorial, go to engineering (if not there) and open help
    if (appPage !== pages.PAGE_ENGINEERING) {
      dispatch(setMainPage(pages.PAGE_ENGINEERING));
    }
    dispatch(openHelp(page.code));
  } else {
    // Otherwise, go to correct main page and close help if open
    if (page.category === 'build') {
      if (appPage !== pages.PAGE_BUILD) {
        dispatch(setMainPage(pages.PAGE_BUILD));
      }
    } else {
      if (appPage !== pages.PAGE_RESEARCH) {
        dispatch(setMainPage(pages.PAGE_RESEARCH));
      }
    }

    if (isHelpOpen) {
      dispatch(closeHelp());
    }

    dispatch({
      type: c.RESEARCH_SET_PAGE,
      page: page,
    });
  }
};

export const openHelp = (code) => ({
  type: c.RESEARCH_OPEN_HELP,
  code,
});

export const closeHelp = () => ({
  type: c.RESEARCH_CLOSE_HELP,
});

/**
 * Like setPage but using code instead of page object itself. (Need to rename and refactor this)
 *
 * @param code
 */
export const displayPage = (code) => (dispatch, getState) => {
  const {
    research: { exercises },
  } = getState();

  const page = exercises.find((ex) => ex.code === code);
  dispatch(setPage(page));
};

export const nextPage = () => (dispatch, getState) => {
  const {
    research: { sequence, sequenceIndex, exercises, isHelpOpen },
    app: { page },
  } = getState();

  if (sequenceIndex < sequence.length - 1) {
    const nextIndex = sequenceIndex + 1;
    const nextCode = sequence[nextIndex];
    const nextPage = exercises.find((ex) => ex.code === nextCode);

    dispatch(setPage(nextPage));
  }
};

export const prevPage = () => (dispatch, getState) => {
  const {
    sequence,
    sequenceIndex,
    exercises,
    isHelpOpen,
  } = getState().research;

  if (sequenceIndex > 0) {
    const nextIndex = sequenceIndex - 1;
    const nextCode = sequence[nextIndex];
    const nextPage = exercises.find((ex) => ex.code === nextCode);

    dispatch(setPage(nextPage));
  }
};

export const gotoDesignChallenge = () => (dispatch, getState) => {
  const {
    research: { exercises },
  } = getState();
  const exercise = exercises.find((ex) => ex.category === 'spec');

  dispatch(setPage(exercise));
};
